module.exports = __webpack_public_path__ + "img/Hummingbirds_2.34fb8adb.png";